<template>
  <div
    :class="{ 'search-competences--loading': loading }"
    class="search-competences">
     <div class="search-competences__search">
      <search-local-search
        :list="searchList"
        placeholder="Sök kompetenser"
        queryType="skills">
      </search-local-search>
    </div>

    <search-competences-suggestions />
      <af-h3 class="search-competences__header">Välj bland kompetenser</af-h3>
    <div v-if="loading" class="spinner-wrap">
      <af-spinner></af-spinner>
    </div>
    <div v-else class="search-competences__columns">
      <div class="search__column">
        <ul>
          <af-expansion-panel
            v-for="model in tree.columnOne"
            :key="model.path"
            :model="model"
            queryType="skills">
          </af-expansion-panel>
        </ul>
      </div>

       <div class="search__column">
        <ul>
          <af-expansion-panel
            v-for="model in tree.columnTwo"
            :key="model.path"
            :model="model"
            queryType="skills">
          </af-expansion-panel>
        </ul>
      </div>

      <div class="search__column">
        <ul>
          <af-expansion-panel
            v-for="model in tree.columnThree"
            :key="model.path"
            :model="model"
            queryType="skills">
          </af-expansion-panel>
        </ul>
      </div>
    </div>

    <search-clear queryType="skills"></search-clear>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Icon from '@/components/Icon'
import AfH3 from '@/components/AfH3'
import AfExpansionPanel from '@/components/AfExpansionPanel'
import AfSpinner from '@/components/AfSpinner'
import SearchClear from './SearchClear'
import SearchLocalSearch from './SearchLocalSearch'
import SearchCompetencesSuggestions from './SearchCompetencesSuggestions'
import { UPDATE_TAB_COLUMN } from '@/store/actionTypes'
import { mapState } from 'vuex'

export default {
  name: 'SearchCompetences',

  components: {
    AfExpansionPanel,
    AfH3,
    AfSpinner,
    Icon,
    SearchClear,
    SearchLocalSearch,
    SearchCompetencesSuggestions
  },

  data() {
    return {
      searchList: [],
      loading: 0,
      competences: []
    }
  },

  computed: {
    ...mapState({
      tree: state => state.tree.skills,
      skills: state => state.query.skills
    })
  },

  mounted() {
    if (this.skills.length > 0) {
      this.skills.forEach(skill => {
        window.eventBus.$emit('openExpansionPanel', {
          ...skill,
          type: 'skills'
        })
      })
    }
  },

  apollo: {
    experienceData: {
      query: gql`
        query Competences($language: LanguageCode) {
          competencegroups(language: $language) {
            name
            path
          }
          competences(path: "*", language: $language) {
            name
            path
          }
        }
      `,
      fetchPolicy: 'cache-and-network',
      loadingKey: 'loading',
      variables() {
        return {
          language: 'sv'
        }
      },
      skip() {
        return this.tree.columnOne.length > 0
      },
      update({ competencegroups, competences }) {
        this.searchList = [...competencegroups, ...competences]
        this.buildRecursiveStructure(competencegroups, competences)
      }
    }
  },

  methods: {
    buildRecursiveStructure(competencegroups, competences) {
      if (competencegroups.length === 0 || this.tree.columnOne.length > 0) {
        return
      }

      const recursive = competencegroups.map(area =>
        Object.freeze({
          ...area,
          children: competences
            .filter(group => {
              return (
                area.path ===
                group.path
                  .split('.')
                  .slice(0, 2)
                  .join('.')
              )
            })
            .map(comp => Object.freeze(comp))
        })
      )

      const split = Math.ceil(recursive.length / 3)

      this.$store.commit(UPDATE_TAB_COLUMN, {
        payload: {
          columnOne: recursive.slice(0, split),
          columnTwo: recursive.slice(split, split * 2),
          columnThree: recursive.slice(split * 2, split * 3)
        },
        type: 'skills'
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-competences {
  background-color: var(--color-white);

  @media (--bp-larger-than-tablet) {
    padding: var(--spacing) var(--spacing-medium);
  }
}

.spinner-wrap {
  padding-bottom: 50px;
  padding-top: 50px;
}

.search-competences--loading {
  padding-bottom: 5px;

  @media (--bp-larger-than-tablet) {
    padding-bottom: 0;
  }
}

.search-competences__search {
  margin-bottom: var(--spacing-third);
  padding: var(--spacing-half);
  padding-bottom: 0;

  @media (--bp-larger-than-tablet) {
    display: grid;
    grid-column-gap: var(--spacing-half);
    grid-template-columns: 1fr 2fr;
    margin-bottom: var(--spacing);
    padding: 0;
  }
}

.search-competences__header {
  @media (--bp-nis-extra-small) {
    margin-left: var(--spacing-half);
  }
}

.search-field-competences__footer {
  margin-top: 40px;
}

.search-competences__columns {
  @media (--bp-larger-than-tablet) {
    display: grid;
    grid-column-gap: var(--spacing-half);
    grid-template-columns: repeat(3, 1fr);
  }

  @media (--ie11) {
    display: block;
  }

  @media (--ie11) and (--bp-desktop) {
    display: -ms-grid;
    -ms-grid-columns: (1fr)[3];
    -ms-grid-rows: 1fr;
  }
}

@media (--ie11) {
  .search__column {
    -ms-grid-row: 1;
  }
  .search__column:nth-child(1) {
    -ms-grid-column: 1;
    margin-right: 15px;
  }
  .search__column:nth-child(2) {
    -ms-grid-column: 2;
    margin-right: 15px;
  }
  .search__column:nth-child(3) {
    -ms-grid-column: 3;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchCompetences.vue